export default __webpack_public_path__ + "static/media/landing_icon.94969de7.svg";